import config from "@/config";
import useDialog from "./useDialog";
import { ModalTransition } from "@/Components";
import IntercomBlockedDialog from "@/Components/Modules/Dialogs/IntercomBlockedDialog.vue";

export default function useIntercomBlockedDialog() {
    const { toggleDialog } = useDialog();

    const showIntercomBlockedDialog = (event) => {
        toggleDialog(
            IntercomBlockedDialog,
            ModalTransition,
            {},
            event,
            config.dialogs.modals.zindex,
            true
        );
    };

    return {
        showIntercomBlockedDialog,
    };
}
